<template>
  <v-container>
    <div id="contaBancaria">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <div
            v-if="exibirData"
            class="text-right"
            style="font-size: 12px; font-weight: bold;"
          >
            Atualização Saldo Bancário: {{ dataAtualizacao }}
          </div>
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
            mobile-breakpoint="0"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Conta Corrente
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Saldo Atual
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in contasBancarias"
                :key="item.id"
              >
                <td
                  id="desc_conta"
                  style="text-align: left;"
                >
                  {{ item.desc_conta }}
                </td>
                <td
                  id="saldoConta"
                  class="text-right"
                  :style="getColor(item.saldo)"
                >
                  {{ item.saldo }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import FluxoCaixa from '../../../../../services/fluxocaixa'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowSaldoContas',
    emits: ['updateDadosSaldoContas'],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },
    data: () => ({
      styleObject: {
        color: '#4CAF50',
      },
      styleSaldoBancario: {
        color: '#4CAF50',
      },
      loading: false,
      error: null,
      select: [],
      headersContaBancaria: [
        { text: 'Conta Corrente', value: 'desc_conta', width: '200px', class: 'black--text title' },
        { text: 'Saldo Atual', value: 'saldo', width: '200px', align: 'right', class: 'black--text title' },
      ],
      contasBancarias: [],
      $dataAtualizacao: '',
      exibirData: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    created () {
      eventEmit.$on('update-fluxo', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-fluxo', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (select) {
        this.select = select

        this.showSaldo()
      },

      async showSaldo () {
        this.loading = true

        this.exibirData = false

        this.contasBancarias = []

        await FluxoCaixa.showSaldoContas(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.dataAtualizacao = resposta.data.dataAtualizacao

            this.contasBancarias = resposta.data.saldoContas.map((item) => {
              var listaContas = ({
                id: item.id,
                desc_conta: item.desc_conta,
                saldo: parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaContas
            })

            eventEmit.$emit('update-dados-saldo-contas', this.contasBancarias)
          } else {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirData = true
        })
      },

      getColor (value) {
        var negativo = value.substr(0, 1)

        if (negativo === '-') {
          return 'color: red'
        } else {
          return 'color: green'
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #contaBancaria {
       width: 100%;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #contaBancaria {
      width: 100%;
    }
  }
</style>
